// extracted by mini-css-extract-plugin
export default {"header":"_V-z","logo":"aW-z","signin":"bW-z"};